<script setup lang="ts">
import type { LearningPathsUsersAttendeesModel } from "@simbelapp/order-sdk";
import { useLearningPathAttendees } from "~/composables/learning-path/useLearningPathAttendees";
import { useFormats } from "~/composables/utils/useFormat";
import type { PropType } from "vue";
import UserIcon from "~/components/Header/UserIcon.vue";

const { toDateDisplay } = useFormats();
defineProps({
  row: { type: Object as PropType<LearningPathsUsersAttendeesModel> },
});

const { headers } = useLearningPathAttendees();
</script>
<template #row="{ row }">
  <td v-if="headers[0]?.visible">
    <div class="index_row gap-1">
      <UserIcon :initials="row?.displayValue?.avatar"> </UserIcon>
      <span>{{ row?.displayValue?.value !== "" ? row?.displayValue?.value : "-" }}</span>
    </div>
  </td>
  <td v-if="headers[1]?.visible">
    <div class="index_row">
      <div>{{ row?.email ?? "-" }}</div>
    </div>
  </td>
  <td v-if="headers[2]?.visible">
    <div class="index_row">
      {{ row?.createdAt ? toDateDisplay(row?.createdAt) : "-" }}
    </div>
  </td>
  <td v-if="headers[3]?.visible">
    <div class="index_row">
      <div>
        {{ row?.legalEntityName ?? "-" }}
      </div>
    </div>
  </td>
  <td v-if="headers[4]?.visible">
    <div class="index_row">
      <div>
        {{ row?.completionRate && Number.isFinite(row?.completionRate) ? `${Math.round(row?.completionRate)}%` : "-" }}
      </div>
    </div>
  </td>
  <td v-if="headers[5]?.visible">
    <div class="index_row">
      <div>
        {{
          row?.durationHours && Number.isFinite(row?.durationHours)
            ? `${row?.attendedHours}/${row?.durationHours}h`
            : "-"
        }}
      </div>
    </div>
  </td>
  <td v-if="headers[6]?.visible">
    <div class="index_row">
      <div>{{ row?.score && Number.isFinite(row?.score) ? `${row?.score}%` : "-" }}</div>
    </div>
  </td>
</template>
<style scoped lang="scss"></style>
